import { makeStyles, createStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => createStyles({
  root: {
    padding: theme.spacing(0.5),
    flexGrow: 1,
    backgroundColor: theme.palette.background.default
  },
  toolbar: theme.mixins.toolbar,
  card: { textAlign: 'center' }
}));

export default {};
